import { render, staticRenderFns } from "./ElFormItem.vue?vue&type=template&id=512ec8f2"
import script from "./ElFormItem.vue?vue&type=script&lang=js"
export * from "./ElFormItem.vue?vue&type=script&lang=js"
import style0 from "./ElFormItem.vue?vue&type=style&index=0&id=512ec8f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports